<ng-container [formGroup]="warehouse">
  <div class="card-body">
    <div class="d-flex">
      <h2>Warehouse Name</h2>

    </div>
    <div class="form-row" >
      <div class="form-group col-12">
        <label for="name" class="custom_label"> Name *</label>
        <input type="text" #htmlInputElement id="name" formControlName="name" class="form-control" placeholder="Warehouse Name" name="name">
        <app-validation-error [formGroup]="warehouse" [controlName]="'name'"></app-validation-error>
      </div>

      <div class="form-group col-12">
        <label for="email" class="custom_label"> Email *</label>
        <input type="email" id="email" formControlName="email" class="form-control" placeholder="Warehouse Email" name="email" >
        <app-validation-error [formGroup]="warehouse" [controlName]="'email'"></app-validation-error>
      </div>
      <div class="form-group col-12">
        <label for="phone" class="custom_label"> Phone *</label>
        <input type="tel" id="phone" formControlName="phone" phoneMask class="form-control" placeholder="Warehouse Phone" name="phone">
        <app-validation-error [formGroup]="warehouse" [controlName]="'phone'"></app-validation-error>
      </div>
      <div class="form-group col-12">
        <label for="fax" class="custom_label"> Fax </label>
        <input type="tel" id="fax" formControlName="fax" phoneMask class="form-control" placeholder="Warehouse Fax" name="fax">
        <app-validation-error [formGroup]="warehouse"  [controlName]="'fax'" [messagePhoneNumber]="'Invalid Fax Number'"></app-validation-error>
      </div>
    </div>
  </div>
</ng-container>
